import React from 'react';
import { Tabs } from 'antd';
import PlansList from './PlansList';
import PaymentHistory from './PaymentHistory';
import TrialSettings from './TrialSettings';
import ExportReports from './ExportReports';

const SubscriptionBillingPage = () => (
    <div style={{ padding: 24 }}>
        <h2>Subscription & Billing</h2>
        <Tabs defaultActiveKey="1" items={[
            { key: '1', label: 'Plans List', children: <PlansList /> },
            { key: '2', label: 'Payment History', children: <PaymentHistory /> },
            { key: '3', label: 'Trial Settings', children: <TrialSettings /> },
            { key: '4', label: 'Export Reports', children: <ExportReports /> },
        ]} />
    </div>
);
export default SubscriptionBillingPage; 